import React from 'react';
import { Skeleton } from '../Skeleton';
const DoctorVoiceLoader = ({ isPOll }) => {
  return (
    <>
      <div className="w-100 rounded-3 dbDoctorVoiceIn overflow-hidden bg-white shadow position-relative h-100 p-3 p-md-4">
        <div className="w-100 d-flex justify-content-between align-items-center dbV2FeaturedBoxTtl pb-3 pb-md-4 border-bottom border-light">
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width={100} height={30} />
          </div>
          <Skeleton variant="circular" width={20} height={20} />
        </div>
        <div className="w-100 dbDoctorVoiceContent dbBoxSlide position-relative z-1 pt-3 pt-md-4">
          <div className="w-100" id="questionBox">
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="60%" height={20} />
          </div>

          <div className="clearfix"></div>
          <div className="w-100 dbDoctorVoiceAns mt-20 p-0">
            <div className="w-100 dbDoctorVoiceOptions px-4">
              {[1, 2, 3, 4].map((_opt, _idx) => (
                <Skeleton
                  variant="rounded"
                  width="80%"
                  height={30}
                  className="p-0 mb-4 position-relative"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorVoiceLoader;
